import { makeStyles } from "tss-react/mui";
const styles = makeStyles()(({ tokens })=>({
        label: {
            color: tokens.colors.text.light.tertirary,
            fontSize: tokens.typography.variant.body3.fontSize
        },
        countdown: {
            fontSize: tokens.typography.variant.body3.fontSize,
            color: tokens.colors.text.light.primary
        },
        countdownDisabled: {
            color: tokens.colors.text.light.tertirary
        }
    }));
const RedoCountdown_styles = styles;
export default RedoCountdown_styles;
